import trackingSourceForm from './_form'
import template from './edit.pug'

export default Vue.extend({
  template: template(),
  components: {
    trackingSourceForm
  },
  data() {
    return {
      ready: false,
      data: {},
      errors: {}
    }
  },
  watch: {
    '$route.params.id': {
      immediate: true,
      handler() {
        this.$setPageTitle(this.$t('trackingSources.edit.title'))
        this.loadData()
      }
    }
  },

  methods: {
    loadData() {
      this.ready = false
      API.trackingSources.show(this.$route.params.id).then(response => {
        this.data = response
        this.ready = true

        this.$setBreadcrumbs([
          {label: this.$t('breadcrumbs.trackingSources.index'), route: {name: 'tracking-sources-index'}},
          {label: this.$t('breadcrumbs.trackingSources.edit', {name: this.data.name}), route: {}}
        ])
      })
    },

    updateCallCenter(data) {
      API.trackingSources.update(this.$route.params.id, data).then(() => {
        this.$notifications.success(this.$t('trackingSources.edit.succesfullyUpdated'))
        this.$router.push({name: 'tracking-sources-index'})
      }, errors => {
        this.errors = errors
      })
    }
  }
})
